"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This file is auto-generated by prebuild.js. Do not edit!
var tf = require("@tensorflow/tfjs");
exports.default = tf;
